// Modules
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app.routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DirectivesModule } from './directives/directives.module';
import { RefreshButtonModule } from './components/refresh-button/refresh-button.module';

// Components
import { AppComponent } from './app.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoadingModule } from './components/loading/loading.module';

// Services
import { NavigationService } from './services/navigation.service';
import { TokenInterceptor } from './services/token-interceptor';
import { OfflineService } from './services/offline.service';
import { TitleService } from './shared/title.service';
import { NewRelicErrorHandlerService } from './services/new-relic-error-handler.service';
import { PipesModule } from './modules/pipes.module';
import { environment } from 'src/environments/environment';
import { CourseSearchInterceptor } from './services/course-search-interceptor.service';
import { AccountSearchInterceptor } from './services/account-search-interceptor.service';
import { segmentAnalyticsBrowserProvider } from './services/analytics.service';
import { DeviceService } from './services/device.service';
import { INDEXED_DB_CONFIG } from './services/indexed-db/indexed-db.config';
import MobileDetect from 'mobile-detect';

const md = new MobileDetect(window.navigator.userAgent);

@NgModule({
  declarations: [
    AppComponent,
    SideNavComponent
  ],
  bootstrap: [AppComponent], imports: [BrowserModule,
    TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: `.json?v=${environment.static.organisationAppConfig[0].currentVersion}`
      })
    }),
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    DirectivesModule,
    MatIconModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatDialogModule,
    MatMenuModule,
    RefreshButtonModule,
    LoadingModule,
    PipesModule], providers: [
    segmentAnalyticsBrowserProvider,
    NavigationService,
    OfflineService,
    TitleService,
    DeviceService,
    { provide: ErrorHandler, useClass: NewRelicErrorHandlerService },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CourseSearchInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AccountSearchInterceptor,
      multi: true
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 5000,
        verticalPosition: 'bottom',
        horizontalPosition: 'center',
        panelClass: 'otb-snack'
      }
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        panelClass: 'otb-dialog',
        hasBackdrop: true,
        minWidth: md.isPhoneSized() ? '100vw' : '672px',
        maxWidth: md.isPhoneSized() ? '100vw' : '672px',
      }
    },
    {
      provide: INDEXED_DB_CONFIG,
      useValue: {
        name: 'assessApp',
        version: 3,
        stores: [
          {
            name: 'offline-data',
          }
        ]
      }
    },
    { provide: 'initialHref', useValue: window.location.href },
    provideHttpClient(withInterceptorsFromDi()),
  ]
})

export class AppModule {
  constructor() { }
}
